export const LOGO_URL = "https://customer-assets.emergentagent.com/job_assuntiva-pro/artifacts/qth9gafn_Assietica%20Soc.Coop.%20%2860%20x%2030%20cm%29%20%2830%20x%2030%20cm%29%20%28800%20x%20200%20px%29.png";

export const AGENCY = {
  name: "Assietica Soc. Coop. — Società Benefit",
  tagline: "Agenzia Generale · Servizi Assicurativi per il Terzo Settore e la Cooperazione",
  email: "agenzia@assietica.it",
  pec: "cdsp@pec.confcooperative.it",
  rui: "A000480096",
  sedi: [
    { city: "Macomer", addr: "Viale Gramsci, 8G", tel: "0785 747193", cell: "373 7288673" },
    { city: "Bosa", addr: "Via Azuni, 14", tel: "0785 460385", cell: "375 6440085" },
    { city: "Cagliari", addr: "Piazza Unione Sarda 39", tel: "", cell: "339 3958177" },
  ],
};
